<template>
  <span><a style="color: var(--primary) !important;" v-bind:href="content.options.url"
            @click.prevent="$emit('responseevent', {placementTest: true})"
  >{{translate(content.options.label)}}</a>
  </span>
</template>

<script>
    export default {
        name: "linkComponent",
        props:{
            content: Object,
        },
        methods: {
            translate(text) {
                const el = document.querySelector('#placementtestapp')
                const language = {
                    fr: {
                        text: 'ici'
                    }
                }
                if (el.dataset.lang === 'fr') return language.fr.text
                return text
            },
        },
    }
</script>

<style scoped>

</style>